package com.neurobs.ccabserver.translation.components.translationreplacement.components

import com.neurobs.ccabserver.translation.states.{TranslationSubSearchStateGenerator, TranslationUpdateProgress}
import com.neurobs.react.semanticui.{UiButtonFactory, UiMessageFactory}
import org.scalajs.dom.window
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks.useEffect
import slinky.core.facade.ReactElement

@react
object ProgressView {
  case class Props()
  val component = FunctionalComponent[Props] { props =>

    val translationSubSearchState = TranslationSubSearchStateGenerator.accessState

    useEffect(() => {
      translationSubSearchState.updateProgressState.value.foreach(progress => {
        if (progress.isComplete) {
          window.setTimeout(() => {
            translationSubSearchState.updateProgressState.setValue(None)
          }, 3000)
        }
      })

    }, Vector(translationSubSearchState.updateProgressState.value))

    def Element(progress: TranslationUpdateProgress) = {
      val successCount = progress.totalSuccesses
      val errorCount = progress.errors.length
      val total = progress.totalUpdates
      var message = s"${successCount}/${total} translations saved"
      if (errorCount > 0) {
        message = message + s", ${errorCount} errors"
      }
      UiButtonFactory.Button(message, () => {})("primary")
    }

    translationSubSearchState.updateProgressState.value match {
      case None => null
      case Some(progress) => Element(progress)
    }
  }
}
